<div>
    <div class="row" *ngIf="unknownAccountId">
        <div class="col">
            <i class="fas fa-exclamation-triangle"></i> Unknown user
        </div>
    </div>
    <div class="row" *ngIf="!unknownAccountId">
        <div class="col">
            <div class="background-hover" [formGroup]="accountDetailFormGroup">
                <h3>Account Detail</h3>
                <div class="row">
                    <div class="col-6">
                        <div class="mb-3">
                            <label for="accountDetailAccountIdInput">Account ID</label>
                            <input type="text" class="form-control" id="accountDetailAccountIdInput" value="{{ account_detail?.account_id }}" readonly>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="mb-3">
                            <label for="accountDetailRegistrationDateInput">RegistrationDate</label>
                            <input type="text" class="form-control" id="accountDetailRegistrationDateInput" value="{{ account_detail?.registration_date | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}" readonly>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="mb-3">
                            <label for="accountDetailEmailInput">Email</label>
                            <div class="float-end" *ngIf="!context">
                                <div>
                                    <span class="text-muted">
                                        <i class="fas fa-hourglass-half"></i> Checking...
                                    </span>
                                </div>
                            </div>
                            <div class="float-end" *ngIf="context" (mouseenter)="hoverEmailStatus = true" (mouseleave)="hoverEmailStatus = false">
                                <div [hidden]="hoverEmailStatus">
                                    <span class="text-success" *ngIf="context.email_validated">
                                        <i class="fas fa-check-circle"></i> Validated
                                    </span>
                                    <span class="text-danger" *ngIf="!context.email_validated">
                                        <i class="fas fa-exclamation-circle"></i> Not Validated
                                    </span>
                                </div>
                                <div [hidden]="!hoverEmailStatus">
                                    <span class="text-muted" style="cursor: pointer;" (click)="hoverEmailStatus = false; updateJwtContext();">
                                        <i class="fas fa-sync-alt"></i> Refresh
                                    </span>
                                </div>
                            </div>
                            <input type="email" class="form-control" id="accountDetailEmailInput" formControlName="accountDetailEmailInput" placeholder="Email...">
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="mb-3">
                            <label for="accountDetailFirstNameInput">Firstname</label>
                            <input type="text" class="form-control" id="accountDetailFirstNameInput" formControlName="accountDetailFirstNameInput" placeholder="Firstname...">
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="mb-3">
                            <label for="accountDetailLastNameInput">Lastname</label>
                            <input type="text" class="form-control" id="accountDetailLastNameInput" formControlName="accountDetailLastNameInput" placeholder="Lastname...">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="mb-3">
                            <label for="accountDetailLocaleInput">Locale</label>
                            <input type="text" class="form-control" id="accountDetailLocaleInput" formControlName="accountDetailLocaleInput" placeholder="Locale (fr, en , zh, ...)">
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="mb-3">
                            <label for="accountDetailTimeZoneInput">TimeZone</label>
                            <input type="text" class="form-control" id="accountDetailTimeZoneInput" formControlName="accountDetailTimeZoneInput" placeholder="TimeZone (Europe/Paris, Asia/Shanghai, ...)">
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="mb-3">
                            <label for="accountDetailRoleInput">Role</label>
                            <input type="text" class="form-control" id="accountDetailRoleInput" formControlName="accountDetailRoleInput" placeholder="Role... (user, test, admin)">
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <div class="row gx-1">
                        <div class="col-auto">
                            <button class="btn btn-sm btn-primary" [disabled]="accountDetailFormGroup.invalid" (click)="saveAccountDetail()">
                                <i class="fas fa-save"></i> Save
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-sm btn-outline-primary" (click)="showModal = 'confirm-validate'">
                                <i class="fas fa-ellipsis-h"></i> Validate email
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-sm btn-outline-primary" (click)="showModal = 'confirm-reset'">
                                <i class="fas fa-ellipsis-h"></i> Reset password
                            </button>
                        </div>
                    </div>

                    <div class="modal" style="background-color: rgba(255, 255, 255, 0.75)" tabindex="-1" [style.display]="showModal == 'confirm-validate' ? 'block' : 'none'">
                        <div class="modal-dialog modal-dialog-centered modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <b>Confirmation</b>
                                </div>
                                <div class="modal-body">
                                    Do you want to resend the welcome email to <code>{{ account_detail?.email }}</code> ?
                                    <p class="text-danger"><small>An email will be sent to invite the user to validate his email.</small></p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="showModal = null; updateJwtContext();">Close</button>
                                    <button type="button" class="btn btn-sm btn-primary" (click)="resendWelcomeEmail()">Resend email</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal" style="background-color: rgba(255, 255, 255, 0.75)" tabindex="-1" [style.display]="showModal == 'confirm-reset' ? 'block' : 'none'">
                        <div class="modal-dialog modal-dialog-centered modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <b>Confirmation</b>
                                </div>
                                <div class="modal-body">
                                    Do you want to reset password for this account <code>{{ account_detail?.email }}</code> ?
                                    <p class="text-danger"><small>An email will be sent to invite the user to choose a new password.</small></p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="showModal = null; updateJwtContext();">Close</button>
                                    <button type="button" class="btn btn-sm btn-primary" (click)="resendResetPassword()">Reset password</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal" style="background-color: rgba(255, 255, 255, 0.75)" tabindex="-1" [style.display]="showModal == 'confirm-validate-response' ? 'block' : 'none'">
                        <div class="modal-dialog modal-dialog-centered modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <b>Email sent successfully</b>
                                </div>
                                <div class="modal-body">
                                    The user should receive again the welcome email with a button to validate his email.<br>
                                    Or if you want to validate immediately the email in place of the user, just open this url:<br>
                                    <code>{{ confirmValidateUrl }}</code><br>
                                    <p class="text-danger"><small>But be aware that this url can only be opened a single time.</small></p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="showModal = null; updateJwtContext();">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal" style="background-color: rgba(255, 255, 255, 0.75)" tabindex="-1" [style.display]="showModal == 'confirm-reset-response' ? 'block' : 'none'">
                        <div class="modal-dialog modal-dialog-centered modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <b>Email sent successfully</b>
                                </div>
                                <div class="modal-body">
                                    The user should receive an email with a link to a form to choose a new password.<br>
                                    Or if you want to choose a new password in place of the user, just open this url:<br>
                                    <code>{{ confirmResetUrl }}</code><br>
                                    Then fill the form with the password of your choice, and communicate it to the user.<br>
                                    <p class="text-danger"><small>But be aware that this form can only be submitted a single time.</small></p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="showModal = null; updateJwtContext();">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <hr>
            <div class="background-hover" [formGroup]="personalFormGroup">
                <h3>Personal Info</h3>
                <div class="row">
                    <div class="col">
                        <div class="mb-3">
                            <label for="personalNickNameInput">Nickname</label>
                            <input type="text" class="form-control" id="personalNickNameInput" formControlName="personalNickNameInput" placeholder="Nickname...">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="personalGenderInput">Gender</label>
                            <input type="text" class="form-control" id="personalGenderInput" formControlName="personalGenderInput" placeholder="Gender (MALE, FEMALE)">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="personalCountryInput">Country</label>
                            <input type="text" class="form-control" id="personalCountryInput" formControlName="personalCountryInput" placeholder="Country (FR, US, CN, ...)">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="personalDateOfBirthInput">DateOfBirth</label>
                            <input type="text" class="form-control" id="personalDateOfBirthInput" formControlName="personalDateOfBirthInput" placeholder="DateOfBirth... (YYYY-MM-DD)">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="mb-3">
                            <label for="personalHeightInput">Height</label>
                            <input type="text" class="form-control" id="personalHeightInput" formControlName="personalHeightInput" placeholder="Height...">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="personalHeightUnitInput">Height Unit</label>
                            <input type="text" class="form-control" id="personalHeightUnitInput" formControlName="personalHeightUnitInput" placeholder="Height Unit (METRIC, IMPERIAL)">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="personalWeightInput">Weight</label>
                            <input type="text" class="form-control" id="personalWeightInput" formControlName="personalWeightInput" placeholder="Weight...">
                        </div>
                    </div>
                    <div class="col">
                        <div class="mb-3">
                            <label for="personalWeightUnitInput">Weight Unit</label>
                            <input type="text" class="form-control" id="personalWeightUnitInput" formControlName="personalWeightUnitInput" placeholder="Weight Unit  (METRIC, IMPERIAL)">
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <button class="btn btn-sm btn-primary" [disabled]="personalFormGroup.invalid" (click)="savePersonalInfo()">
                        <i class="fas fa-save"></i> Save
                    </button>
                </div>
            </div>
            <hr>
            <div *ngIf="personal?.avatar">
                <h3>Avatar</h3>
                <div class="text-center mb-3">
                    <img src="{{ personal?.avatar }}" width="128px" height="128px" class="rounded-circle">
                </div>
            </div>
            <hr>
            <ul class="nav nav-tabs mb-3">
                <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" data-bs-target="#devices" (click)="loadDevices()">Devices</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" data-bs-target="#tracking" (click)="loadTrackingData()">Tracking</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" data-bs-target="#heartrate" (click)="loadHeartRateData()">HeartRate</a></li>
                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" data-bs-target="#sleep" (click)="loadSleepData()">Sleep</a></li>
            </ul>
            <div class="tab-content" style="min-height: 400px;">
                <div id="devices" class="tab-pane active">
                    <div>
                        <table class="table table-sm table-striped table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">S/N</th>
                                    <th scope="col">Model</th>
                                    <th scope="col">Sim</th>
                                    <th scope="col">Firmware</th>
                                    <th scope="col">Paired</th>
                                    <th scope="col">Pairing</th>
                                    <th scope="col">Unpairing</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let device of devices">
                                    <td scope="row">
                                        <span class="">
                                            <a [routerLink]="['/devices', device.id]">
                                                <code>#{{ device.id }}</code>
                                            </a>
                                        </span>
                                    </td>
                                    <td scope="row">
                                        <span class="">{{ device.model }}</span>
                                    </td>
                                    <td scope="row">
                                        <span class="">{{ device.sim }}</span>
                                    </td>
                                    <td scope="row">
                                        <span class="">{{ device.firmwareName }}</span><br>
                                        <span class="">{{ device.firmwareVersion }}</span><br>
                                    </td>
                                    <td scope="row">
                                        <span class="">{{ device.paired }}</span>
                                    </td>
                                    <td scope="row">
                                        <span class="text-muted">first: {{ device.firstPairing | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</span><br>
                                        <span class="text-muted">last: {{ device.lastPairing | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</span><br>
                                    </td>
                                    <td scope="row">
                                        <span class="text-muted" *ngIf="device.lastUnPairing">last: {{ device.lastUnPairing | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <p *ngIf="devices && devices.length == 0">
                            <i class="fas fa-exclamation-triangle"></i> No devices found
                        </p>
                    </div>
                    <div>
                        <table class="table table-sm table-striped table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">Name (Version)</th>
                                    <th scope="col">Phone (Version)</th>
                                    <th scope="col">Last info</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let application of applications">
                                    <td scope="row">
                                        <span class="">{{ application.appName ? application.appName : '-' }} {{ application.appVersion ? '(' + application.appVersion + ')' : '' }}</span>
                                    </td>
                                    <td scope="row">
                                        <span class="">{{ application.model ? application.model : '-' }} {{ application.osVersion ? '(' + application.osVersion + ')' : '' }}</span>
                                    </td>
                                    <td scope="row">
                                        <span class="text-muted">{{ application.lastUpdate | date: 'yyyy-MM-dd HH:mm UTC' : 'UTC' }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <p *ngIf="applications && applications.length == 0">
                            <i class="fas fa-exclamation-triangle"></i> No applications found.
                        </p>
                    </div>
                </div>
                <div id="tracking" class="tab-pane">
                    <div [hidden]="!trackingSteps">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingSteps" (click)="trackingStepsClick($event)"></canvas>
                        </div>
                    </div>
                    <div [hidden]="!trackingDistance">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingDistance" (click)="trackingDistanceClick($event)"></canvas>
                        </div>
                    </div>
                    <div [hidden]="!trackingCalories">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingCalories" (click)="trackingCaloriesClick($event)"></canvas>
                        </div>
                    </div>
                    <div [hidden]="!trackingDuration">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingDuration" (click)="trackingDurationClick($event)"></canvas>
                        </div>
                    </div>
                    <hr>
                    <div [hidden]="!trackingStepsWeek">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingStepsWeek" (click)="trackingStepsWeekClick($event)"></canvas>
                        </div>
                    </div>
                    <div [hidden]="!trackingDistanceWeek">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingDistanceWeek" (click)="trackingDistanceWeekClick($event)"></canvas>
                        </div>
                    </div>
                    <div [hidden]="!trackingCaloriesWeek">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingCaloriesWeek" (click)="trackingCaloriesWeekClick($event)"></canvas>
                        </div>
                    </div>
                    <div [hidden]="!trackingDurationWeek">
                        <div style="position: relative; height: 200px;">
                            <canvas id="trackingDurationWeek" (click)="trackingDurationWeekClick($event)"></canvas>
                        </div>
                    </div>
                </div>
                <div id="heartrate" class="tab-pane">
                    <div [hidden]="!heartRateYearChart">
                        <div style="position: relative; height: 200px;">
                            <canvas id="heartRateYearChart" (click)="heartRateYearChartClick($event)"></canvas>
                        </div>
                    </div>
                    <hr>
                    <div [hidden]="!heartRateWeekChart">
                        <div style="position: relative; height: 200px;">
                            <canvas id="heartRateWeekChart" (click)="heartRateWeekChartClick($event)"></canvas>
                        </div>
                    </div>
                </div>
                <div id="sleep" class="tab-pane">
                    <div [hidden]="!sleepChart">
                        <div style="position: relative; height: 200px;">
                            <canvas id="sleepChart" (click)="sleepYearChartClick($event)"></canvas>
                        </div>
                    </div>
                    <hr>
                    <div [hidden]="!sleepWeekChart">
                        <div style="position: relative; height: 200px;">
                            <canvas id="sleepWeekChart" (click)="sleepWeekChartClick($event)"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>